import React, { useMemo } from 'react';

import { statusItems } from '../../../providers/statusItems';
import { useTrackingRefuel } from '../../../hooks/useTrackingRefuel';

import { Container, TabItem, TabText, Count } from './styles';

type TabsProps = {
  activeTab: number;
  handleActiveTab: (tab: number) => void;
};

const Tabs: React.FC<TabsProps> = ({ activeTab, handleActiveTab }) => {
  const { counterData } = useTrackingRefuel();

  const isEmpty = Object.keys(counterData).length === 0;

  const dataItems = useMemo(() => {
    const data = statusItems.map((item) => {
      if (isEmpty) {
        return {
          ...item,
          count: 0,
        };
      }

      const counts = counterData?.statusOrderCount?.filter((counter) => {
        if (Array.isArray(item?.statusId)) {
          return item.statusId.includes(counter.status);
        }
        return counter.status === item.statusId;
      });

      const totalOccurrences = counts.reduce(
        (acc, curr) => acc + (curr.occurence || 0),
        0
      );

      return {
        ...item,
        count: totalOccurrences,
      };
    });

    return data;
  }, [counterData, isEmpty]);

  return (
    <Container>
      {dataItems.map((item) => (
        <TabItem
          key={item.id}
          active={activeTab === item.id}
          onClick={() => {
            handleActiveTab(item.id);
          }}
        >
          <TabText active={activeTab === item.id}>{item.name}</TabText>
          {!!item.count && <Count>{item.count}</Count>}
        </TabItem>
      ))}
    </Container>
  );
};

export default Tabs;
